/**
 * BIGSIGNS — Pipedrive Web Form helpers v4.1 (FINAL)
 *
 * DO NOT rewrite data-pd-webforms or iframe.src — ever.
 * (That caused PPC-only layout bugs, then direct-after-PPC chrome + autofill loss.)
 *
 * Pipedrive UTM-parameter hidden fields read parent URL on ad landings.
 * We only mirror utm_* into sessionStorage to append on thank-you navigation.
 *
 * Thank-you: Pipedrive REDIRECT to /pages/thank-you must not run in the iframe
 * (Shopify X-Frame-Options: DENY). On Pipedrive success postMessage, top-level
 * location.replace once. This file is a no-op on /pages/thank-you (stops refresh loop).
 */
(function () {
  if (window.__bigsignsPipedriveHelpers) return;
  window.__bigsignsPipedriveHelpers = true;

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var STORAGE_KEY = 'bigsigns_utm_params';
  var TY_FLAG = 'bigsigns_ty_breakout_done';
  var THANK_YOU_PATH = '/pages/thank-you';
  var THANK_YOU = 'https://www.bigsigns.com/pages/thank-you';

  function onThankYouPage() {
    try {
      return window.location.pathname.indexOf(THANK_YOU_PATH) !== -1;
    } catch (e) {
      return false;
    }
  }

  // Inert on thank-you — prevents continuous refresh.
  if (onThankYouPage()) {
    try { sessionStorage.removeItem(TY_FLAG); } catch (e) {}
    return;
  }

  // New form page view → allow a future successful submit to break out again.
  try { sessionStorage.removeItem(TY_FLAG); } catch (e) {}

  function parseUtms(search) {
    var params = new URLSearchParams(search || '');
    var out = {};
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v != null && v !== '') {
        try { out[k] = decodeURIComponent(v); } catch (e) { out[k] = v; }
      }
    });
    return out;
  }

  function readStored() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }

  function writeStored(obj) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch (e) {}
  }

  var fromUrl = parseUtms(window.location.search);
  if (Object.keys(fromUrl).length) {
    writeStored(Object.assign({}, readStored(), fromUrl));
  }

  function thankYouUrl() {
    var map = Object.assign({}, readStored(), parseUtms(window.location.search));
    try {
      var u = new URL(THANK_YOU);
      UTM_KEYS.forEach(function (k) {
        if (map[k]) u.searchParams.set(k, map[k]);
      });
      return u.toString();
    } catch (e) {
      return THANK_YOU;
    }
  }

  var breakingOut = false;

  function goThankYou() {
    if (breakingOut || onThankYouPage()) return;
    try {
      if (sessionStorage.getItem(TY_FLAG) === '1') return;
      sessionStorage.setItem(TY_FLAG, '1');
    } catch (e) {}
    breakingOut = true;
    var dest = thankYouUrl();
    try {
      window.top.location.replace(dest);
    } catch (e) {
      window.location.replace(dest);
    }
  }

  function isPipedriveOrigin(origin) {
    if (!origin) return false;
    try {
      var host = new URL(origin).hostname;
      return host === 'pipedrive.com' || host.endsWith('.pipedrive.com');
    } catch (e) {
      return String(origin).indexOf('pipedrive.com') !== -1;
    }
  }

  function looksLikePipedriveSubmit(data) {
    if (data == null) return false;
    try {
      var s = typeof data === 'string' ? data : JSON.stringify(data);
      s = s.toLowerCase();
      return s.indexOf('pipedrive') !== -1 && s.indexOf('submit') !== -1;
    } catch (e) {
      return false;
    }
  }

  window.addEventListener('message', function (event) {
    if (onThankYouPage() || breakingOut) return;
    if (!isPipedriveOrigin(event.origin)) return;
    if (!looksLikePipedriveSubmit(event.data)) return;
    goThankYou();
  });
})();
